import { atom } from 'jotai'
import { InterviewStageDefinition } from '../services/api'

// Interview stages are admin-configurable and live in DynamoDB
// (interview-stage-definitions), loaded once at app mount and read from here.
// There is deliberately no hardcoded fallback list: an empty array means the
// stage table has not been seeded, and callers render the raw status instead.
export const interviewStageDefinitionsAtom = atom<InterviewStageDefinition[]>([])
export const interviewStagesLoadingAtom = atom(false)
